import React from 'react'
import Resx from '@/components/Resx'
import {
  FormGroup,
  Input,
  Label
} from 'reactstrap'

class LookupEntitySelect extends React.Component {
  constructor (props, context) {
    super(props, context)

    this.state = {
      defaultValue: props.defaultValue ? props.defaultValue : props.entities.find(() => true).id,
      entities: props.entities
    }
  }

  componentDidMount () {
    this.onChange(this.state.defaultValue)
  }

  onChange (value) {
    this.setState({
      defaultValue: value
    }, () => this.props.onChange(value))
  }

  render () {
    const options = this.state.entities.length ? this.state.entities.map(e => <option key={e.id} value={e.id}>{e.name} - {e.latinName}</option>)
      : <span />

    return (
      <FormGroup>
        <Label><Resx name='Common.NavigationEntity' />:</Label>
        <Input type='select' defaultValue={this.state.defaultValue} onChange={(e) => this.onChange(e.target.value)} disabled={this.props.isReadOnly}>
          {options}
        </Input>
      </FormGroup>
    )
  }
}

export default LookupEntitySelect



// WEBPACK FOOTER //
// ./src/components/codeLists/lookupEntitySelect.js